import GlobalMessage from './GlobalMessage';

export default GlobalMessage;
